import React from "react";

export type Props = {
  email: string;
};

export const LoginLocationErrorMessage: React.FunctionComponent<Props> = (props) => (
  <span>
    You might need to sign in from another account. We’ve sent an email to{" "}
    <strong>{props.email}</strong> with next steps. Check your junk folder if you don&apos;t see
    it your inbox.
  </span>
);

export default LoginLocationErrorMessage;
